import React from 'react';

// Components
import TiptapTextIndentControlTool from './TiptapTextIndentControlTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const TiptapIndentTextTool = (props: ToolbarToolProps) => (
    <TiptapTextIndentControlTool command="sinkListItem" iconName="toolbar-indent" {...props} />
);

export default TiptapIndentTextTool;
